import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  errorStatus: null,
  has502Error: false,
  lastErrorTimestamp: null,
};

const globalErrorSlice = createSlice({
  name: "globalError",
  initialState,
  reducers: {
    setError: (state, action) => {
      state.errorStatus = action.payload;
      if (action.payload === 502) {
        state.has502Error = true;
        state.lastErrorTimestamp = Date.now();
      }
    },
    clearError: (state) => {
      state.errorStatus = null;
      state.has502Error = false;
      state.lastErrorTimestamp = null;
    },
    clear502Error: (state) => {
      state.has502Error = false;
      if (state.errorStatus === 502) {
        state.errorStatus = null;
      }
    },
  },
});

export const { setError, clearError, clear502Error } = globalErrorSlice.actions;
export default globalErrorSlice.reducer;